module.exports = __webpack_public_path__ + "static/media/companyLogo.a9848f93.png";